import React from 'react';

import withAuthentication from 'hoc/authentication';
import modalHelpers from 'helpers/modalHelpers';
import UserProfile from './User/Profile';
import StaffProfile from './Staff/Profile';

const isStaff = user => {
  const { groups } = user;
  return groups.includes('staff');
};

const onSubmit = (user, history) => () => {
  if (!Object.keys(user.properties).length) {
    const destination = user.groups.includes('staff')
      ? '/manage-request'
      : '/new-request';
    modalHelpers(
      'Votre profil a été créé',
      "Vous allez être redirigé à la page de déclaration d'une activité.",
      history,
      destination,
      'success',
    );
  }
};

export const Profile = ({ user, history, ...props }) => (
  isStaff(user)
    ? <StaffProfile user={user} onSubmit={onSubmit(user, history)} {...props} />
    : <UserProfile user={user} onSubmit={onSubmit(user, history)} {...props} />
);


export default withAuthentication(Profile);



// WEBPACK FOOTER //
// ./src/components/Profile/index.js